import React, { FC, ReactNode, useEffect, useMemo } from "react";
import { ThemeProvider as Provider, createTheme } from "@mui/material/styles";

import { themeConfig, themePalette } from "@theme";
import { useGetCurrentCompanyInfo } from "@api";
import { ThemeVariants, useCustomThemeStore } from "@store/customTheme";
import { useUserStore } from "@store/user";

interface ThemeProvider {
  children: ReactNode;
}

const ThemeProvider: FC<ThemeProvider> = ({ children }) => {
  const { color, setColor } = useCustomThemeStore();
  const { user } = useUserStore();

  const {
    currentCompanyInfo,
    isSuccessCurrentCompanyInfo,
    refetchCurrentCompanyInfo,
  } = useGetCurrentCompanyInfo(user);

  useEffect(() => {
    if (isSuccessCurrentCompanyInfo) {
      setColor(
        (currentCompanyInfo?.appearance?.palette as string as ThemeVariants) ??
          "default",
      );
    }
  }, [isSuccessCurrentCompanyInfo, currentCompanyInfo, setColor]);

  useEffect(() => {
    if (user?.activeCompanyId !== currentCompanyInfo?.companyId) {
      refetchCurrentCompanyInfo();
    }
  }, [user]);

  const theme = useMemo(() => {
    return createTheme({
      ...themeConfig,
      palette: themePalette(color),
    });
  }, [color]);

  return <Provider theme={theme}>{children}</Provider>;
};

export default ThemeProvider;
